import Box from '@material-ui/core/Box';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import React__default from 'react';
import { Helmet } from 'react-helmet';

const useStyles = (props) => makeStyles(
  (theme) => ({
    container: {
      width: "100%",
      display: "flex",
      flexDirection: "row",
      flexWrap: "wrap",
      justifyContent: "flex-end",
      alignItems: "center",
      marginBottom: theme.spacing(2),
      textAlign: props.textAlign
    },
    leftItemsBox: {
      flex: "1 1 auto",
      minWidth: 0,
      overflow: "visible"
    },
    rightItemsBox: {
      flex: "0 1 auto",
      display: "flex",
      flexDirection: "row",
      flexWrap: "wrap",
      alignItems: "center",
      marginLeft: theme.spacing(1),
      minWidth: 0,
      overflow: "visible"
    },
    description: {},
    title: {
      display: "inline-flex",
      marginBottom: 0
    }
  }),
  { name: "BackstageContentHeader" }
);
const ContentHeaderTitle = ({ title, className }) => /* @__PURE__ */ React__default.createElement(
  Typography,
  {
    variant: "h4",
    component: "h2",
    className,
    "data-testid": "header-title"
  },
  title
);
function ContentHeader(props) {
  const {
    description,
    title,
    titleComponent: TitleComponent = void 0,
    children,
    textAlign = "left"
  } = props;
  const classes = useStyles({ textAlign })();
  const renderedTitle = TitleComponent ? TitleComponent : /* @__PURE__ */ React__default.createElement(ContentHeaderTitle, { title, className: classes.title });
  return /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement(Helmet, { title }), /* @__PURE__ */ React__default.createElement(Box, { className: classes.container }, /* @__PURE__ */ React__default.createElement(Box, { className: classes.leftItemsBox }, renderedTitle, description && /* @__PURE__ */ React__default.createElement(Typography, { className: classes.description, variant: "body2" }, description)), /* @__PURE__ */ React__default.createElement(Box, { className: classes.rightItemsBox }, children)));
}

export { ContentHeader };
//# sourceMappingURL=ContentHeader.esm.js.map
